import { useTranslation } from 'react-i18next';
import { ChoiceCard, DialogShellSection } from '@bliks-io/ui';
import {
  SUCCESSOR_ENTITY_TYPES,
  SUCCESSOR_STATUS_TYPES,
  filterSuccessorTypes,
  type SuccessorChooserKey,
  type SuccessorTypeOption
} from '@/lib/successorEntityMapping';

interface SuccessorTypeChooserBodyProps {
  onSelect: (type: SuccessorChooserKey) => void;
  hideExternalContact?: boolean;
  hideNone?: boolean;
  hideUnclear?: boolean;
}

export function SuccessorTypeChooserBody({
  onSelect,
  hideExternalContact,
  hideNone,
  hideUnclear
}: SuccessorTypeChooserBodyProps) {
  const { t } = useTranslation();

  const entityVisible = filterSuccessorTypes(SUCCESSOR_ENTITY_TYPES, {
    hideExternalContact
  });
  const statusVisible = filterSuccessorTypes(SUCCESSOR_STATUS_TYPES, {
    hideNone,
    hideUnclear
  });

  const renderRow = (
    { value, icon: Icon, labelKey, sublabelKey }: SuccessorTypeOption,
    tone: 'green' | 'amber'
  ) => (
    <ChoiceCard
      key={value}
      tone={tone}
      icon={<Icon className="h-4 w-4" />}
      title={t(labelKey)}
      hint={sublabelKey ? t(sublabelKey) : undefined}
      onClick={() => onSelect(value)}
    />
  );

  return (
    <div className="flex flex-col gap-4">
      <DialogShellSection title={t('entityPicker.successor.sectionWhoOrWhat')}>
        <div className="grid grid-cols-2 gap-2">
          {entityVisible.map((opt) => renderRow(opt, 'green'))}
        </div>
      </DialogShellSection>

      {statusVisible.length > 0 && (
        <DialogShellSection title={t('entityPicker.successor.sectionNotYetDefined')}>
          <div className="grid grid-cols-2 gap-2">
            {statusVisible.map((opt) => renderRow(opt, 'amber'))}
          </div>
        </DialogShellSection>
      )}
    </div>
  );
}
